import { render, staticRenderFns } from "./tablaCentrosConsumo.vue?vue&type=template&id=d5bf167a&scoped=true&"
import script from "./tablaCentrosConsumo.vue?vue&type=script&lang=js&"
export * from "./tablaCentrosConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bf167a",
  null
  
)

export default component.exports